import { render, staticRenderFns } from "./BtnAtualizarItem.vue?vue&type=template&id=16f87958"
import script from "./BtnAtualizarItem.vue?vue&type=script&lang=js"
export * from "./BtnAtualizarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports